import { useScrollReveal } from '../../../hooks/useScrollReveal';

export default function ApproachSection() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section className="bg-[#FAFAF8] py-24 md:py-32 px-6 md:px-10 lg:px-16 overflow-hidden">
      <div ref={ref} className="w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center">
          {/* Left image */}
          <div
            className={`relative transition-all duration-900 ${
              isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'
            }`}
          >
            <div className="relative aspect-[4/5] rounded-xl overflow-hidden max-w-md">
              <img
                src="https://public.readdy.ai/ai/img_res/eb6b29c08acafc8bdde674ff3b628549.jpg"
                alt="Approche WABICH – studio de design à Lille"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating accent box */}
            <div className="absolute -bottom-6 -right-6 bg-[#1A1A1A] text-white p-6 hidden lg:block rounded-lg">
              <p
                className="text-xs tracking-widest uppercase text-gray-400 mb-1"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                Basé à
              </p>
              <p
                className="text-base text-white"
                style={{ fontFamily: 'Cormorant Garamond, serif', fontWeight: 400, fontSize: '18px' }}
              >
                Lille, France
              </p>
            </div>
          </div>

          {/* Right content */}
          <div
            className={`transition-all duration-900 delay-200 ${
              isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'
            }`}
          >
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-px bg-gray-300" />
              <span
                className="text-xs tracking-widest uppercase text-gray-400"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                Notre approche
              </span>
            </div>

            <h2
              className="mb-8 text-gray-900"
              style={{
                fontFamily: 'Cormorant Garamond, serif',
                fontWeight: 300,
                fontSize: 'clamp(28px, 3.5vw, 48px)',
                lineHeight: '1.15',
              }}
            >
              Chaque projet est réalisé avec <em style={{ fontStyle: 'italic' }}>attention</em> afin de proposer des solutions simples, efficaces et adaptées.
            </h2>

            <p
              className="text-sm text-gray-500 leading-loose mb-8"
              style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300 }}
            >
              Nous croyons que le design créatif n&apos;est pas seulement une question d&apos;esthétique. 
              C&apos;est une discipline qui sert votre communication, renforce votre identité et parle 
              à votre audience cible de manière directe et mémorable.
            </p>

            <div className="space-y-4">
              {[
                { label: 'Écoute', text: 'Nous comprenons vos besoins avant tout' },
                { label: 'Rigueur', text: 'Chaque détail est soigné et cohérent' },
                { label: 'Adaptabilité', text: 'Des solutions sur-mesure pour chaque client' },
              ].map((item) => (
                <div key={item.label} className="flex items-start gap-4 pb-4 border-b border-gray-100">
                  <div className="w-2 h-2 rounded-full bg-gray-300 mt-1.5 flex-shrink-0" />
                  <div>
                    <span
                      className="text-sm text-gray-900 font-medium"
                      style={{ fontFamily: 'Inter, sans-serif', fontWeight: 500 }}
                    >
                      {item.label}
                    </span>
                    <span
                      className="text-sm text-gray-500 ml-2"
                      style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300 }}
                    >
                      — {item.text}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
